import React, { Component } from 'react';  
import { Route } from 'react-router-dom';  
import AdminFooter from './AdminFooter';
import AdminHeader from './AdminHeader';
import AdminMenu from './AdminMenu';

const AdminLayout = ({ children }) => {   
  var componentData = {children}
    return(
      <div >
          <AdminHeader/>
          <div id="layoutSidenav">
            <AdminMenu />
            <div id="layoutSidenav_content">
            <main style={{width:"98%"}}>
                <div class="container-fluid p-0" style={{border: "1px solid grey", margin:"1%" ,borderRadius:"5px"}}>
                      <div style={{backgroundColor:"rgb(117, 160, 205)",color:"white"}}>
                    <h3 className="text-center" style={{marginLeft:"5%"}}>{componentData.children.props.title}</h3>
                    </div>
                    {children}
                </div>
            </main>
        </div>
          </div>
      </div>
    )  
};  
  
const AdminLayoutRoute = ({component: Component, ...rest}) => {  
  var parameter = {...rest}
  function checkToken(){
    if(localStorage.getItem("token") === "" || localStorage.getItem("token") === null  || localStorage.getItem("role") !== 'admin'){
      
       window.location.href ="/signin";
     
    }else{
      return (
        <Route {...rest} render={matchProps => (  
          <AdminLayout>  
              <Component {...matchProps} title = {parameter.title} />  
          </AdminLayout>  
        )} /> 
      )

      // window.location.href ="/signin";
      //alert("something went to wrong")
    }
  }
  return (  
      <div>
        {checkToken()}
      </div>
  )  
};  
  
export default AdminLayoutRoute;